import React from 'react'
import { Divider, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import FavoriteIcon from '@material-ui/icons/Favorite'
import SearchIcon from '@material-ui/icons/Search'
import PersonIcon from '@material-ui/icons/Person'
import { useAuthRedirect } from '../../../../hooks/use-auth-redirect'
import { useMenuForNotAuthenticated } from './menu-for-not-authenticated.hook'

type MenuForNotAuthenticatedProps = {
  closeDrawer: () => void
}

export const MenuForNotAuthenticated: React.FC<MenuForNotAuthenticatedProps> = (
  props
): React.ReactElement => {
  const { closeDrawer } = props

  const { onSearchClickHandler } = useMenuForNotAuthenticated(closeDrawer)

  const { t } = useTranslation()
  const { authRedirectHandle, handleLoginRedirect } = useAuthRedirect()

  /**
   * Creates a menu button item with custom click handler
   */
  const menuButton = (
    label: string,
    onClick: (e: React.MouseEvent<HTMLDivElement>) => void,
    icon?: React.ReactElement
  ) => (
    <ListItem button onClick={onClick}>
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText>{label}</ListItemText>
    </ListItem>
  )

  return (
    <List>
      {menuButton(t('header.menu.donate'), (e) =>
        authRedirectHandle(e, '/donate', '/donate'),
        <FavoriteIcon />
      )}
      {menuButton(t('header.menu.search'), onSearchClickHandler, <SearchIcon />)}
      <Divider />
      {menuButton(t('header.menu.login'), () => handleLoginRedirect('/search'), <PersonIcon />)}
    </List>
  )
}
